import React from 'react';
import {FormTemplateField} from '../../../others/'
import {Input, Textarea, Dropdown} from '../../../form'

let Epilation = props => {
  const { baseName, baseFieldValues, isTemplate, isOpen } = props;
  return (
    <div className="card-body">
      <div className="row">
        <FormTemplateField
          isTemplate={isTemplate}
          name={`${baseName}[fields][eye]`}
          baseName={`${baseName}[fields][eye]`}
          fieldValues={baseFieldValues['eye']}
          component={Dropdown} 
          isOpen={isOpen}
          data={[{key: 'od', value: 'OD'}, {key: 'os', value: 'OS'}, {key: 'ou', value: 'OU'}]} 
          textField="value" 
          valueField="key" 
          wrapperClasses="col-6 form-group label-icons"
         />
        
        <FormTemplateField
          isTemplate={isTemplate}
          name={`${baseName}[fields][location]`}
          baseName={`${baseName}[fields][location]`}
          fieldValues={baseFieldValues['location']}
          component={Input}
          isOpen={isOpen}
          className="form-control"
          wrapperClasses="col-6 form-group label-icons"
          type="findingField"
         />
        
        <FormTemplateField
          isTemplate={isTemplate}
          name={`${baseName}[fields][number]`}
          baseName={`${baseName}[fields][number]`}
          fieldValues={baseFieldValues['number']}
          component={Input}
          isOpen={isOpen}
          placeholder="Type to search"
          className="form-control"
          wrapperClasses="col-6 form-group label-icons"
          type="findingField"
         />
        
        <FormTemplateField
          isTemplate={isTemplate}
          name={`${baseName}[fields][comments]`}
          baseName={`${baseName}[fields][comments]`}
          fieldValues={baseFieldValues['comments']}
          component={Textarea}
          isOpen={isOpen}
          rows={3}
          className="form-control"
          wrapperClasses="col-12 form-group label-icons"
         />
        
      </div>
    </div>
  )
}
export default Epilation;